// utils/navigation-utils.js
// const atob = require('atob');`
// const btoa = require('btoa');
import { showLog, showWarn, showError } from 'src/utils/debug-log';

const mybtoa = (jsonObject) => {
  const utf8String = JSON.stringify(jsonObject);
  // Encode the base64 string for URL
  const encodedString = encodeURIComponent(utf8String);
  // Convert to base64String
  return btoa(encodedString);
};

const myatob = (base64String) => {
  try {
    const param = atob(base64String);
    // Decode the URL-encoded string
    const decodedString = decodeURIComponent(param);
    // Convert to json object
    return JSON.parse(decodedString);
  } catch (error) {
    return null;
  }
};

export const nextNavigate = (
  router,
  state,
  nextLink,
  backLink = '',
  nextParam,
) => {
  const jsonObj = {
    bVal: {
      ...state,
      link: backLink,
    },
  };
  if (nextParam) {
    jsonObj.vals = nextParam;
  }
  
  try {
    const base64String = mybtoa(jsonObj);
    const target = nextLink.replace(':param', base64String);
    router.push(target);
  } catch (err) {
    showError(err);
    router.replace('/404');
  }
};

export const backNavigate = (router, jsonObj) => {
  if (!jsonObj || !jsonObj.link) {
    router.replace('/404');
    return;
  }
  const link = jsonObj.link;

  let query = jsonObj.filters ? jsonObj.filters.query : '';
  if (query) query = mybtoa(query);

  const params = {};
  if (jsonObj.page) params.page = jsonObj.page;
  if (jsonObj.rowsPerPage) params.rowsPerPage = jsonObj.rowsPerPage;
  if (query) params.query = query;

  if (Object.keys(params).length > 0) {
    router.push(link, params);
  }else{
    if (link.includes(':param'))
      router.back();
    else
      router.push(link);
  }
};

export const handleNavigateAtTarget = (base64String) => {
  if (!base64String) return {};
  try {
    const jsonString = myatob(base64String);
    if (jsonString && typeof jsonString === 'object') {
      return jsonString;
    }
  } catch (err) {
    showError(err);
  }
  return {};  // Always return an object, never null
};

export const handleNavigateAtSource = (urlParam) => {
 // Use cached value if valid
  const cache = parseInt(localStorage.getItem('cache_rowsPerPage'), 10);
  const defaultRows = Number.isFinite(cache) && cache > 0 ? cache : 5;
  const jsonObj = { page: 0, rows: defaultRows };
  
  const searchParams = new URLSearchParams(urlParam.search);
  const searchObject = Object.fromEntries(searchParams.entries());

  if (Object.keys(searchObject).length > 0) {
    if (searchObject.page) {
      const page = parseInt(searchObject.page, 10);
      if (!isNaN(page)) jsonObj.page = page;
    }

    // Optionally allow overriding rows via query param
    if (searchObject.rowsPerPage) {
      const rows = parseInt(searchObject.rowsPerPage, 10);
      if (!isNaN(rows)) jsonObj.rows = rows;
    }

    let temp = searchObject.query;
    if (temp) jsonObj.query = myatob(temp);

    temp = searchObject.holder;
    if (temp) jsonObj.holder = temp;
  }
  // Remove params
  removeParams(urlParam, searchParams);

  return jsonObj;
};

// Remove params without reloading the page
const removeParams = (location, param) => {
  if (!param) param = new URLSearchParams(location.search);

  if (param) {
    param.delete('page');
    param.delete('rows');
    param.delete('query');

    const newSearch = param.toString();
    // Construct the new URL
    const newUrl = newSearch
      ? `${location.pathname}?${newSearch}`
      : location.pathname;
    // Update the URL without reloading the page
    window.history.replaceState(null, '', newUrl);
  }
};

export const gotoListPage = (
  router,
  nextLink,
  jsonObject,
  searchHolder,
) => {
  if(!jsonObject || Object.keys(jsonObject).length === 0){
    router.push(nextLink);
  }else{
    try {
      const base64String = mybtoa(jsonObject);
      const params = {
        query: base64String, 
        // page: 0, rows: 5,
      };
      if(searchHolder){
        params.holder = searchHolder;
      }
      router.push(nextLink, params);
     } catch (err) {
       router.replace('/404');
     }
  }
};
